import "./ProjectSection.scss";
import Container from "react-bootstrap/Container";
// import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
// import SkillCard from "../SkillCard/SkillCard";
import { useEffect, useState } from "react";

import hackathon from "../../assets/images/hackathon.svg";
import capstoneClient from "../../assets/images/capstone-client.svg";
import capstoneServer from "../../assets/images/capstone-server.svg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { faGithubAlt } from "@fortawesome/free-brands-svg-icons";

const projectArr = [
  {
    title: "MyFoodies - Client Side",
    index: 0,
    url: "https://gabriela-terasaka-capstone.netlify.app/",
    description:
      "Responsive web application inspired to make it easier for people to create and share grocery list with friends and family. It has also been designed to allow the user to add the items they bought from the list to their virtual pantry and manage its inventory.",
    type: "Front-End",
    tech: ["React", "Axios", "Sass", "Netlify", "VS Code"],
    image: capstoneClient,
    github: "https://github.com/GabrielaTerasaka/Gabriela-Terasaka-Capstone",
  },
  {
    title: "MyFoodies - Server Side",
    index: 1,
    url: "https://shrouded-peak-10650.herokuapp.com/",
    description:
      "API that allows the front-end web app to have access to MySQL database that has been deployed on Heroku",
    type: "Back-End",
    tech: ["Node.js", "Express", "MySQL", "JWT", "Heroku"],
    image: capstoneServer,
    github:
      "https://github.com/GabrielaTerasaka/Gabriela-Terasaka-Capstone-Server",
  },
  {
    title: "Let's Make Some Drink",
    index: 3,
    url: "https://brainstation-hackathon.netlify.app/",
    description:
      "A responsive web app using the external Cocktail API (https://www.thecocktaildb.com/) built in a 24hr Hackathon. It allows the user to search drinks by name, category and/or alcoholic.",
    type: "Front-End",
    tech: ["HTML", "Sass", "JS", "Cocktail DB API", "VS Code"],
    image: hackathon,
    github: "https://github.com/GabrielaTerasaka/brainstation-hackathon",
  },
];

export default function SkillSection() {
  const [loader, setLoader] = useState(true);
  const [activeProject, setActiveProject] = useState(0);

  useEffect(() => {
    setTimeout(() => setLoader(false), 500);
  }, []);

  function updateProject(index) {
    if (index !== loader) {
      setActiveProject(index);
    }
  }

  return (
    <section className="projects" id="projects">
      <Container className={!loader ? "" : "container--hidden"}>
        <Row>
          {/* <h3 className="skills__title">My Skills</h3> */}
          <h3 className="projects__title">Featured Projects</h3>
        </Row>
        <Row>
          {/* <Row xs={2} sm={3} md={4} lg={4} xl={5}> */}
          <div className="projects__wrapper">
            <ul className="projects__list">
              {
                // {window.innerWidth > 576 &&
                projectArr.map((project, index) => {
                  return (
                    <li
                      className={`projects__list-item ${
                        index === activeProject
                          ? "projects__list-item--active"
                          : ""
                      }`}
                      key={index}
                      onClick={() => {
                        updateProject(index);
                      }}
                    >
                      {project.title}
                    </li>
                  );
                })
              }
            </ul>
            <div className="projects__details-wrapper">
              <p className="projects__description">
                {projectArr[activeProject].description}
              </p>
              <p className="projects__tech">
                <span className="projects__tech-type">
                  {projectArr[activeProject].type}
                </span>
                : {projectArr[activeProject].tech.join(", ")}
              </p>
              <ul className="projects__links">
                <li>
                  <a
                    href={projectArr[activeProject].url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faExternalLinkAlt}
                      className="projects__icon projects__icon--open"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href={projectArr[activeProject].github}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faGithubAlt}
                      className="projects__icon"
                    />
                  </a>
                </li>
              </ul>

              <a
                className="projects__image"
                href={projectArr[activeProject].url}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="projects__image"
                  src={projectArr[activeProject].image}
                  alt={projectArr[activeProject].title + " web app"}
                />
              </a>
            </div>
            <div className="projects__all-wrapper">
              {projectArr.map((project) => (
                <div className="projects__individual-wrapper">
                  <h4 className="projects__subtitle">{project.title}</h4>
                  <p className="projects__description">{project.description}</p>
                  <p className="projects__tech">
                    <span className="projects__tech-type">{project.type}</span>:{" "}
                    {project.tech.join(", ")}
                  </p>
                  <ul className="projects__links">
                    <li>
                      <a href={project.url} target="_blank" rel="noreferrer">
                        <FontAwesomeIcon
                          icon={faExternalLinkAlt}
                          className="projects__icon projects__icon--open"
                        />
                      </a>
                    </li>
                    <li>
                      <a href={project.github} target="_blank" rel="noreferrer">
                        <FontAwesomeIcon
                          icon={faGithubAlt}
                          className="projects__icon"
                        />
                      </a>
                    </li>
                  </ul>

                  <a
                    className="projects__image"
                    href={project.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="projects__image"
                      src={project.image}
                      alt={project.title + " web app"}
                    />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </Row>
      </Container>
    </section>
  );
}
